<p-toast position="top-right" styleClass="ip-auth-toast"></p-toast>

<div class="signup-container">
  <div class="signup-card">
    <!-- Icon badge -->
    <div class="signup-icon-wrap">
      <i class="pi" [ngClass]="step === 'company' ? 'pi-building' : 'pi-user'"></i>
    </div>

    <!-- Header -->
    @if (step === 'profile') {
      <div class="signup-header">
        <h2 class="signup-title">Complete Your Profile</h2>
        <p class="signup-subtitle">Just a few more details to get you started.</p>
      </div>
    }
    @if (step === 'company') {
      <div class="signup-header">
        <h2 class="signup-title">Tell Us About Your Company</h2>
        <p class="signup-subtitle">Required to set up your employer workspace.</p>
      </div>
    }

    <!-- Error banner -->
    @if (errorMessage) {
      <div class="signup-error">
        <i class="pi pi-exclamation-circle"></i>
        {{ errorMessage }}
      </div>
    }

    <!-- Step 1: name / password -->
    @if (step === 'profile') {
      <form class="signup-form" (ngSubmit)="createAccount()">
        <!-- First name + Last name -->
        <div class="signup-name-row">
          <div class="signup-field">
            <label class="signup-label">First Name <span class="signup-required">*</span></label>
            <input
              class="signup-input"
              type="text"
              [(ngModel)]="firstName"
              name="firstName"
              placeholder="John"
              required
            />
          </div>
          <div class="signup-field">
            <label class="signup-label">Last Name <span class="signup-required">*</span></label>
            <input
              class="signup-input"
              type="text"
              [(ngModel)]="lastName"
              name="lastName"
              placeholder="Doe"
              required
            />
          </div>
        </div>
        <!-- Password (not needed for social logins - account already exists) -->
        @if (!isSocialSignup) {
          <div class="signup-field">
            <label class="signup-label">Password <span class="signup-required">*</span></label>
            <div class="signup-input-wrap">
              <input
                class="signup-input"
                [type]="showPassword ? 'text' : 'password'"
                [(ngModel)]="password"
                name="password"
                placeholder="Create a password"
                required
              />
              <button type="button" class="signup-eye-btn" (click)="showPassword = !showPassword">
                <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
            <p class="signup-hint">Minimum 8 characters.</p>
          </div>
        }
        <!-- Referral code (optional) -- entering a friend's code gets both of
              you 1000 Interpanely Coins once this signup completes. -->
        <div class="signup-field">
          <label class="signup-label"
            >Referral Code <span class="signup-optional">(optional)</span></label
          >
          <input
            class="signup-input"
            type="text"
            [(ngModel)]="referredByCode"
            name="referredByCode"
            placeholder="Got a code from a friend? Enter it here"
          />
          <p class="signup-hint">You and your friend each get 1000 coins once you sign up.</p>
        </div>
        <!-- Submit -->
        <button
          class="signup-btn"
          type="submit"
          [disabled]="loading || !firstName || !lastName || (!isSocialSignup && !password)"
        >
          @if (loading) {
            <i class="pi pi-spin pi-spinner"></i>
          }
          <span>{{ loading ? 'Saving…' : 'Continue' }}</span>
        </button>
      </form>
    }

    <!-- Step 2 (corporate signups only): mandatory company details -->
    @if (step === 'company') {
      <form class="signup-form" (ngSubmit)="saveCompany()">
        <div class="signup-field">
          <label class="signup-label">Company Name <span class="signup-required">*</span></label>
          <input
            class="signup-input"
            type="text"
            [(ngModel)]="companyName"
            name="companyName"
            placeholder="Acme Inc."
            required
          />
        </div>
        <div class="signup-field">
          <label class="signup-label">Industry</label>
          <input
            class="signup-input"
            type="text"
            [(ngModel)]="industry"
            name="industry"
            placeholder="e.g. Software, Finance, Healthcare"
          />
        </div>
        <div class="signup-field">
          <label class="signup-label">Website (optional)</label>
          <input
            class="signup-input"
            type="text"
            [(ngModel)]="website"
            name="website"
            placeholder="https://acme.com"
          />
        </div>
        <!-- Submit, disabled until a company name is entered, so corporate
                        signups can't skip past this step without providing it. -->
        <button class="signup-btn" type="submit" [disabled]="loading || !companyName.trim()">
          @if (loading) {
            <i class="pi pi-spin pi-spinner"></i>
          }
          <span>{{ loading ? 'Saving…' : 'Continue' }}</span>
        </button>
      </form>
    }
  </div>
</div>
